export default __webpack_public_path__ + "static/media/txt1_pc.4ab716e9.png";